export default __webpack_public_path__ + "fe619af6cae2b1b8d6073030a9a63d0b.svg";